// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentViewHeading-Heading_cls1__BDwAo","cls2":"PaymentViewHeading-Heading_cls2__nvbVB PaymentViewHeading-Heading_cls1__BDwAo"};